import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicCartSummaryComponent } from '../../components/public-cart-summary/public-cart-summary.component';
import { Observable } from 'rxjs';
import { PublicCartItemComponent } from '../../components/public-cart-item/public-cart-item.component';
import {
  PublicCartDetails,
  PublicCartItem,
  PublicCartService,
} from '@web/shared/module/shop';
import { Divider } from 'primeng/divider';
import {
  PrimengDividerDirective,
  SpinnerFilledComponent,
  WithLoadingPipe,
} from '@web/shared/ui';
import { isEmptyArray, isNil, isNotNil, Nillable } from '@web/utils';
import { PublicCartEmptyComponent } from '../public-cart-empty/public-cart-empty.component';

@Component({
  selector: 'app-public-cart-details',
  imports: [
    CommonModule,
    PublicCartSummaryComponent,
    PublicCartItemComponent,
    Divider,
    PrimengDividerDirective,
    SpinnerFilledComponent,
    WithLoadingPipe,
    PublicCartEmptyComponent,
  ],
  templateUrl: './public-cart-details.component.html',
  styleUrl: './public-cart-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicCartDetailsComponent {
  private readonly cart = inject(PublicCartService);

  public readonly checkoutClickEvent = output<void>();

  public readonly items$: Observable<PublicCartItem[]>;
  public readonly details$: Observable<Nillable<PublicCartDetails>>;
  protected readonly isNil = isNil;
  protected readonly isEmptyArray = isEmptyArray;
  protected readonly isNotNil = isNotNil;

  public constructor() {
    this.items$ = this.cart.items$;
    this.details$ = this.cart.details$;
  }

  public handleCheckoutClickEvent(): void {
    this.checkoutClickEvent.emit();
  }

  public isNotEmpty(
    items: Nillable<PublicCartItem[]>,
  ): items is PublicCartItem[] {
    return isNotNil(items) && !isEmptyArray(items);
  }
}
